import { actionTypes } from 'redux-resource'
import { store } from '../store'

export const updateResourceSync = (resources: object) => {
  store.dispatch({
    type: actionTypes.UPDATE_RESOURCES,
    resources: resources
  })
}
